// useMcpPlan — the reactive half of `service/mcpPlans.ts` (ORP-21466).
//
// The shell's plan chip must not know how to read an account payload, and the service must stay
// pure, so this composable is the single seam between them. No store: everything it needs is
// already in module 07's read surface.
//
// ⚠ WAVE 1 SCOPE. Only the seat count has a live source today (`account_detail`). The tier and the
// connection counter need FE-15's package read and its `GET /integrations/{ws}` fetch; both stay
// `null` here rather than being guessed, and the chip renders only what resolved. Wiring them is
// an edit to THIS file — no shell component changes.
import { computed, type ComputedRef } from 'vue'

import { readSeatCounter, resolveMcpPlanSummary, type McpPlanSummary } from '../service/mcpPlans'

import { useAccount } from '@/features/account'

export interface UseMcpPlan {
  summary: ComputedRef<McpPlanSummary>
}

export function useMcpPlan(): UseMcpPlan {
  const { accountDetail } = useAccount()

  return {
    summary: computed(() =>
      resolveMcpPlanSummary({
        users: readSeatCounter(accountDetail.value),
      }),
    ),
  }
}
